
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiThreewayStackedInleftBottom75 as ObiThreewayStackedInleftBottom75Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-threeway-stacked-inleft-bottom-75.js';
 
 
 

 
 export const ObiThreewayStackedInleftBottom75 = createComponent({
   react: React,
   tagName: 'obi-threeway-stacked-inleft-bottom-75',
   elementClass: ObiThreewayStackedInleftBottom75Element,
   events: {
     
   }
  });
 
 